const doc = [({"en":({"js":({"ckeditor":({"editor":({"heading_with_number":"Heading %{number}"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;